import React, { memo } from 'react';
import FavoriteIcon from 'components/svg/ico-heart.svg';
import { routes } from 'utils/routing';
import { EventList } from 'api/general/models';
import Image from 'components/common/Image';
import EventCard from './EventCard';
import LoggedOutFavoritePopUp from './LoggedOutFavoritePopUp';

import IconButton from '../IconButton';

interface IProps {
  event: EventList;
  isFavoriteOfflineToggled?: boolean;
  onLogin: () => void;
  onToggleFavorite: (eventId: number) => void;
  onCloseFavoritePopUp: () => void;
  showLocation?: boolean;
  noLocationLiveIcons?: boolean;
  padding?: number;
  userIsRegistered?: boolean;
}

const UserEventCard: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const {
    event,
    isFavoriteOfflineToggled,
    onLogin,
    onToggleFavorite,
    onCloseFavoritePopUp,
    showLocation,
    noLocationLiveIcons,
    padding,
    userIsRegistered,
  } = props;
  const {
    id,
    title,
    organization,
    start_at,
    end_at,
    timezone,
    main_image,
    categories,
    target_ages,
    min_ticket_price,
    max_ticket_price,
    is_hidden_price,
    has_location,
    is_virtual,
    user_favorite,
    default_currency,
    hide_date,
    hide_time,
    ...other
  } = event;

  const FabIcon = FavoriteIcon;

  const handleFabClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onToggleFavorite(event.id);
  };

  return (
    <EventCard
      {...other}
      id={id}
      title={title}
      organizationId={organization.id}
      organizationTitle={organization.title}
      organizationLogo={organization.logo}
      startAt={start_at}
      endAt={end_at}
      timeZone={timezone}
      imageUrl={main_image}
      categories={categories}
      targetAges={target_ages}
      currency={default_currency}
      minTicketPrice={min_ticket_price}
      maxTicketPrice={max_ticket_price}
      hasLocation={showLocation && has_location}
      isVirtual={is_virtual}
      eventRoute={routes.event(id)}
      isPopUpToggled={isFavoriteOfflineToggled}
      organizationRoute={routes.organizationProfile(organization.id)}
      hideDate={hide_date}
      hideTime={hide_time}
      isHiddenPrice={is_hidden_price}
      noLocationLiveIcons={noLocationLiveIcons}
      padding={padding}
      userIsRegistered={userIsRegistered}
      imagePopUp={
        <Image
          variant="rectangle"
          rounded
          alt={title}
          placeholder={<LoggedOutFavoritePopUp onClose={onCloseFavoritePopUp} onLogin={onLogin} />}
        />
      }
      heart={
        <IconButton
          onClick={handleFabClick}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 4,
          }}
        >
          <FabIcon color="secondary" fill={user_favorite ? '#F65675' : 'none'} />
        </IconButton>
      }
    />
  );
};

export default memo(UserEventCard);
